export default __webpack_public_path__ + "static/media/renuma-plus-02.2001c934.png";